import React from 'react';
import { useTranslation } from 'react-i18next';
import AddIcon16 from '@wix/da-ds/pkg/Icons/16x16/Add';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import type { BiEvent } from '@wix/da-bi/pkg/events';

export interface Props {
  disabled?: boolean;
  onClick?: () => void;
  className?: string;
  biData?: BiEvent;
}

const AddColumnButton: React.FC<Props> = ({ className, onClick, disabled, biData }) => {
  const { t } = useTranslation();
  return (
    <TextButton
      variant="edit-purple"
      size="medium"
      icon={AddIcon16}
      onClick={onClick}
      disabled={disabled}
      className={className}
      data-role="edit-control"
      aria-label={t('gruser.widgetbox.button.addColumn')}
      biData={biData}
    >
      {t('gruser.widgetbox.button.addColumn')}
    </TextButton>
  );
};

AddColumnButton.displayName = 'AddColumnButton';

export default AddColumnButton;
